import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import * as yup from "yup";
import { EClientStatus } from "../../../shared/enums/client/EClient";
import { formatDate } from "../../../shared/functions/formatDate";
import { handleError } from "../../../shared/functions/handleError";
import { IClientAction } from "../../../shared/interfaces/client/IClient";
import { ClientService } from "../service";
import ClientForm from "./ClientForm";

export const moduleAssignmentSchema = yup.object({
  moduleId: yup.number().required("validation.required"),
});

export const clientSchema = yup.object({
  email: yup.string().email().required("validation.required"),
  apiKey: yup.string().uuid().required("validation.required"),
  name: yup.string().required("validation.required"),
  description: yup.string().optional(),
  expirationDate: yup.string().required("validation.required"),
  modules: yup.array().of(moduleAssignmentSchema).optional(),
  notificationEmails: yup
    .array()
    .of(yup.string().email("validation.email").required())
    .nullable()
    .optional(),
  status: yup
    .mixed<EClientStatus>()
    .oneOf(Object.values(EClientStatus))
    .required("validation.required"),
});

const ClientCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<IClientAction>({
    resolver: yupResolver(clientSchema) as unknown as Resolver<IClientAction>,
    defaultValues: {
      status: EClientStatus.PENDING,
      apiKey: uuidv4(),
    } as unknown as IClientAction,
  });

  const submitHandler = (formData: IClientAction) => {
    ClientService.create({
      ...formData,
      expirationDate: formatDate(formData?.expirationDate, "YYYY-MM-DD"),
    })
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyCreated", { title: formData?.name }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ClientForm control={control} watch={watch} errors={errors} />
    </form>
  );
};
export default ClientCreate;
